<template>
  <v-card flat class="device-cards-container">
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'CardContainer',
}
</script>

<style scoped lang="scss">
.device-cards-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: varFigma(neutral-99);
  padding: 24px;
  height: 245px;
  border-radius: 8px;
}
</style>
